export const KZ_PHONE_LENGTH = 11;

